export default "<app-header *ngIf=\"isHeaderAllowed\"></app-header>\n<router-outlet></router-outlet>\n<app-footer *ngIf=\"isFooterAllowed\"></app-footer>"